module.exports = __webpack_public_path__ + "static/media/pool.03701160.svg";